import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CesionarioQueryParam, CesionarioSummaryFilter, InvoiceCesionarioQueryParam } from '../formula-view/interfaces/cesionario-viewmodel.interface';
import { Observable } from 'rxjs';
import { PageResult } from 'src/app/common/interfaces/paged-result.interface';
import { CedidoInvoiceDTO, CesionarioReceivedInvoiceDTO, CompanyCesionarioDTO, CompanyCesionarioSummaryDTO } from '../formula-view/interfaces/company-cesionario.interface';
import { environment } from 'src/environments/enviroments';

@Injectable({
  providedIn: 'root'
})
export class CesionariosService {

  constructor(private httpClient: HttpClient) { }

  getCesionarios(queryParams: CesionarioQueryParam): Observable<PageResult<CompanyCesionarioDTO>> {
    const {search, page, pageSize, sortColumn, sortOrder} = queryParams;
    let params = new HttpParams()
    .set('search', search || '')
    .set('sortColumn', sortColumn ||'')
    .set('sortOrder', sortOrder || '')
    .set('page', page)
    .set('size', pageSize);
    const endpoint = `${environment.apiUrl}/company/cesionarios`;
    return this.httpClient.get<PageResult<CompanyCesionarioDTO>>(endpoint, { params: params});
  }

  getReceivedInvoices(companyId: number, queryParams: InvoiceCesionarioQueryParam, filters: CesionarioSummaryFilter): Observable<PageResult<CesionarioReceivedInvoiceDTO>> {
    const { page, size, sortColumn, sortDirection} = queryParams;
    const { search, start, end } = filters;
    let params = new HttpParams()
    .set('search', search ||'')
    .set('start', start.toISOString() ||'')
    .set('end', end.toISOString() ||'')
    .set('page', page)
    .set('size', size)
    .set('sortColumn', sortColumn || '')
    .set('sortOrder', sortDirection ||'');
    const endpoint = `${environment.apiUrl}/company/${companyId}/invoices/received`;
    return this.httpClient.get<PageResult<CesionarioReceivedInvoiceDTO>>(endpoint, {params: params});
  }

  getCesionarioSummary(companyId: number, filter: CesionarioSummaryFilter): Observable<CompanyCesionarioSummaryDTO> {
    const {start, end, search} = filter
    let params = new HttpParams()
    .set('search', search ||'')
    .set('start', start.toISOString() || '')
    .set('end', end.toISOString() || '');
    const endpoint = `${environment.apiUrl}/company/cesionario/${companyId}`;
    return this.httpClient.get<CompanyCesionarioSummaryDTO>(endpoint, {params: params});
  }

  getCedidoInvoices(companyId: number, queryParams: InvoiceCesionarioQueryParam, filters: CesionarioSummaryFilter): Observable<PageResult<CedidoInvoiceDTO>>
  {
    const { page, size, sortColumn, sortDirection} = queryParams;
    const { search, start, end } = filters;
    let params = new HttpParams()
    .set('search', search ||'')
    .set('start', start.toISOString() ||'')
    .set('end', end.toISOString() ||'')
    .set('page', page)
    .set('size', size)
    .set('sortColumn', sortColumn || '')
    .set('sortOrder', sortDirection ||'');
    const endpoint = `${environment.apiUrl}/company/${companyId}/invoices/cedido`;
    return this.httpClient.get<PageResult<CedidoInvoiceDTO>>(endpoint, {params: params});
  }
}
